const payment_consts = {
    payId: "zai_payid_per_user",
    payTo: "zai_payto_agreement"
}

export default payment_consts